module.exports = {
      id: "speaker-usage",
      viewBox: "0 0 15 12",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#speaker",
      toString: function () {
        return this.url;
      }
    }